<template>
  <Sidebar v-if="showDrawer" />
  <!-- z-index por arriba del modal (2000), para que las notificaciones se vean
  también cuando hay un modal abierto -->
  <Notifications
    class="bg-gray-50 fixed left-0 sm:left-auto bottom-0 right-0 sm:mr-4 mb-4 w-full sm:w-6/12 lg:w-4/12 xl:w-3/12 pointer-events-none"
    style="z-index: 2100"
  />
  <div
    v-if="router.currentRoute.value.name !== 'Login'"
    class="md:ml-72 md:mt-10 md:text-left m-4 mt-12 text-center"
  >
    <router-view />
  </div>
  <div v-else>
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useStore } from "@/store/index.store";
import Notifications from "@/components/organisms/notifications/BaseNotifications.vue";
import Sidebar from "@/components/organisms/sidebar/BaseSidebar.vue";
import router from "@/router/index.router";
import { routesWithoutDrawer } from "@/types/router.type";
import { CookieTokenName, getCookieToken } from "@/helpers/cookies.helper";
import { SetInterceptorLogIn } from "@/helpers/auth.helper";
import { ActionTypes as configActionTypes } from "@/store/modules/Config/action-types";

const showDrawer = computed(
  () =>
    !routesWithoutDrawer.includes(
      (router.currentRoute.value.name as string) || ""
    )
);

onMounted(async () => {
  const store = useStore();
  // Check if the user is LoggedIn and updates status
  if (!store.getters.isLoggedIn) {
    const token = getCookieToken(CookieTokenName);
    if (token) {
      await SetInterceptorLogIn(token);
      await store.dispatch(configActionTypes.SET_ISLOGGEDIN, true);
    }
  }
});
</script>
